import {Component, Input, OnInit} from '@angular/core';
import {EmployeeDTO} from '../../../../shared/dto/employee.model';
import {EmployeeService} from '../../../../shared/service/employee.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {EmployeePopupComponent} from '../employee-popup/employee-popup.component';
import {EmployeeComponent} from '../employee.component';
import {SystemUserPopupComponent} from '../system-user-popup/system-user-popup.component';
import swal from "sweetalert2";

@Component({
  selector: 'app-employee-search-table',
  templateUrl: './employee-search-table.component.html',
  styleUrls: ['./employee-search-table.component.scss']
})
export class EmployeeSearchTableComponent implements OnInit {
  @Input() items: EmployeeDTO[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;

  public employeeDTOS: EmployeeDTO[] = [];

  constructor(private employeeService:EmployeeService,
              public modalService: NgbModal,
              private employeeMgt: EmployeeComponent) { }

  ngOnInit() {
    this.loadEmployeeDetails();
  }

  loadEmployeeDetails() {
    this.employeeService.getAllEmployees().subscribe(
      (data: EmployeeDTO[]) => {
        this.employeeDTOS = data;
      }
    )
  }

  onClickUpdate(Item) {
    const modalRef = this.modalService.open(EmployeePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update Employee Details";
    modalRef.componentInstance.id = Item.id;
    modalRef.componentInstance.name =  Item.name;
    modalRef.componentInstance.identificationNo = Item.identificationNo;
    modalRef.componentInstance.address = Item.address;
    modalRef.componentInstance.contactNo1 = Item.contactNo1;
    modalRef.componentInstance.contactNo2 = Item.contactNo2;
    modalRef.componentInstance.designation = Item.employeeDesignation;
    modalRef.componentInstance.email = Item.email;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.employeeMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.employeeMgt.onLoadGetData();
          this.loadEmployeeDetails();
        }
      },
      () => { }
    );
  }

  onClickView(Item) {
    const modalRef = this.modalService.open(EmployeePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View Employee Details";
    modalRef.componentInstance.name =  Item.name;
    modalRef.componentInstance.identificationNo = Item.identificationNo;
    modalRef.componentInstance.address = Item.address;
    modalRef.componentInstance.contactNo1 = Item.contactNo1;
    modalRef.componentInstance.contactNo2 = Item.contactNo2;
    modalRef.componentInstance.designation = Item.employeeDesignation;
    modalRef.componentInstance.email = Item.email;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.employeeMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

  saveSystemUser(Item) {
    const modalRef = this.modalService.open(SystemUserPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.employeeId =  Item.id;
    modalRef.componentInstance.name =  Item.name;
  }

  onDelete(Item) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then((result)=> {
      if(result.value) {
        const id = Item.id;
        this.employeeService.deleteEmployee(id).subscribe(
          (res: boolean) => {
            if (res === true) {
              swal.fire("Success", "Details Deleted successfully", "success");
              this.items.splice(Item.id, 1);
              this.loadEmployeeDetails();
            } else if (res === false) {
              swal.fire("Sorry!", "Details can't be deleted.Ongoing records available for the selected user..!", "error");
            }
          },
          (error) => {
            console.log(error);
            swal.fire("Sorry!", "Something went wrong...!", "error");
          },
          () => {
          }
        );
      }
      }, reason => {
      }
    );
  }

}
